import { combineReducers, configureStore } from "@reduxjs/toolkit";
import globalFilter from "../generics/AppHOC/reducer";
import accounts from "../views/accounts/reducer";
import applications from "../views/applications/reducer";
import adKey from "../views/insights/PredictiveWidgetTop/AnomalyDetection/reducer";
import predictiveNetworks from "../views/insightsApplicationInfo/reducer";
import overview from "../views/overview/reducer";
import reports from "../views/reports/reportsTabListView/reducer";
import app360Report from "../views/reports/reportTemplates/app360Summary/reducer";
import applicationSummary from "../views/reports/reportTemplates/applicationSummary/reducer";
import executiveSummary from "../views/reports/reportTemplates/executiveSummary/reducer";
import linkAvailability from "../views/reports/reportTemplates/linkAvailability/reducer";
import linkSLA from "../views/reports/reportTemplates/linkSLA/reducer";
import linkUtilization from "../views/reports/reportTemplates/linkUtilization/reducer";
import siteSummary from "../views/reports/reportTemplates/siteSummary/reducer";
import topClientsReport from "../views/reports/reportTemplates/topClientsReport/reducer";
import trend from "../views/sidebar/TrendAnalysis/reducer";
import sites from "../views/sites/SitesComponent/reducer";
import { IS_PRODUCTION } from "../utils/enums";

const rootReducer = combineReducers({
  vanalytics: combineReducers({
    app: combineReducers({
      globalFilter,
    }),
    accounts,
    adKey,
    app360_report: app360Report,
    applications,
    applicationSummary,
    executive_summary: executiveSummary,
    linkAvailability,
    linkSLA,
    linkUtilization,
    overview,
    predictiveNetworks,
    reports,
    siteSummary,
    sites,
    topClientsReport,
    trend,
  }),
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  devTools: IS_PRODUCTION === false,
});

export default store;
